import { Typography } from '@mui/material';

// This component is assumed to be used in the DataGrid
function ColumnVerticalHeader({ headerName }) {
	return <Typography variant="overline">{headerName}</Typography>;
}

export default ColumnVerticalHeader;
